import { MaterialReactTable } from "material-react-table";
import React, { useRef, useState, useEffect } from "react";
import { download, generateCsv, mkConfig } from "export-to-csv";
import { Box, Button } from "@mui/material";
import AlertTemplateMessage from "../Configuration/AlertTemplate/AlertTemplateMessage";
import { getReportViewColumns, formatUTCToLocal, formatUTCToOffset } from "./ReportViewColumnConfig";
import { CircularProgress } from "@mui/material"; // Add
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';

import {
  getDownloadRequestList,
  getExecuteReport,
} from "../../services/reportService";
import { ConvertDateToUTC } from "../../utils/dateUtils";
import { getReportsDatasetColumns, getReportsDatasetColumnsById } from "../../services/configurationServices";
import { LeftArrowWhite } from "../../assets/images";

const ReportView = () => {
  const [reportData, setReportData] = useState();
  const [transformedReportData, setTransformedReportData] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  const [globalFilter, setGlobalFilter] = useState("");

  const history = useHistory();
  const location = useLocation();

  const { currentReport, reportFromDate, reportToDate } = location.state || {};
  const { DateParameterFlag } = currentReport || {};

  useEffect(() => {
    let loggedInUser = JSON.parse(localStorage.getItem("user"));
    let UserID = loggedInUser?.Id;
    const payload = {
      UserID: UserID,
      //ReportID: currentReport["Report ID"],
      ReportID: currentReport["ReportID"],
      Flag: 1,
    };

    // Only include FromDateTime and ToDateTime if DateParameterFlag is not 0
    if (DateParameterFlag !== 0) {
      payload.FromDateTime = ConvertDateToUTC(reportFromDate);
      payload.ToDateTime = ConvertDateToUTC(reportToDate);
    }

    const fetchReport = async () => {

      const { ReportDataSetID,DataSetName } = currentReport;
      try {
        const response = await getExecuteReport(payload);

        let columnsDataSet;
        if (DataSetName === 'Video Backup Daywise Status'){
          columnsDataSet = await getReportsDatasetColumnsById(ReportDataSetID, currentReport["ReportID"],payload.FromDateTime,payload.ToDateTime);
        }else{
          columnsDataSet = await getReportsDatasetColumnsById(ReportDataSetID, currentReport["ReportID"]);
        }

        setReportColumns(columnsDataSet?.Data || []);

        // Do something with response, e.g. setReportData(response.data);
        const transformed = response?.Data?.map((row) => {
          const newRow = {};
          Object.keys(row).forEach((key) => {
            const newKey = key.replace(/\s+/g, "");
            newRow[newKey] = row[key];
          });
          return newRow;
        });
        setTransformedReportData(transformed || []);
        setReportData(response?.Data);
      } catch (error) {
        console.error("Error fetching report:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchReport();
    // Cleanup function to reset report data when component unmounts
    return () => {
      setReportData([]);
      setReportColumns([]);
      setTransformedReportData([]);
    };
  }, []);

  
  const columns = getReportViewColumns(reportColumns, transformedReportData);

  const tableRef = useRef();

  const handleExportData = (table) => {
    // Check if any filter is applied (global or column)
    const isGlobalFilterActive = !!table.getState().globalFilter;
    const columnFilters = table.getState().columnFilters;
    const isColumnFilterActive = columnFilters && columnFilters.length > 0 && columnFilters.some(f => f.value);

    let exportSourceData;
    if (isGlobalFilterActive || isColumnFilterActive) {
      // If any filter is active, export only filtered data
      const filteredRows = table.getFilteredRowModel().rows;
      exportSourceData = filteredRows.map((row) => row.original);
    } else {
      // No filters: export all data in the table
      exportSourceData = transformedReportData;
    }

    if (!exportSourceData.length) {
      alert("No data to export!");
      return;
    }

    // Only include visible columns
    const visibleColumnIds = table.getVisibleLeafColumns().map((col) => col.id);
    const exportColumns = columns
      .filter((col) => visibleColumnIds.includes(col.accessorKey) && col.accessorKey !== 'OffsetMinutes' && col.header !== 'OffsetMinutes')
      .map((col) => ({
        accessorKey: col.accessorKey,
        header: col.header,
        isDateTime: reportColumns.find(rc => rc.DisplayColumnName.replace(/\s+/g, "") === col.accessorKey)?.ColumnDataType === "DateTime"
      }));

    // Prepare data with header as column header and replace null/undefined with ""
    const exportData = exportSourceData.map((row) => {
      const newRow = {};
      exportColumns.forEach((col) => {
        let value = row[col.accessorKey];
        // Apply UTC to OffsetMinutes conversion for DateTime columns if offset present; otherwise convert to local time
        if (col.isDateTime) {
          const hasOffset = Object.prototype.hasOwnProperty.call(row, 'OffsetMinutes') || Object.prototype.hasOwnProperty.call(row, 'offsetMinutes');
          if (hasOffset) {
            const offsetVal = row.OffsetMinutes ?? row.offsetMinutes ?? 0;
            value = formatUTCToOffset(value, offsetVal);
          } else {
            value = formatUTCToLocal(value);
          }
        }
        newRow[col.header] = value === null || value === undefined ? "" : value;
      });
      return newRow;
    });

    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: `${currentReport["ReportName"]}_${new Date().toISOString().slice(0, 10)}`,
    });

    let csv = generateCsv(csvConfig)(exportData);
    
    // Add the message at the end of the CSV
    csv += '\n*This is a system generated report';
    download(csvConfig)(csv);
  };

  const handleBackToReportIndex = () => {
        history.push({
            pathname: "/report-index",
        });
    }

  return (
    <div className="MainContentMargin">
      <div className="col-lg-12 HMHeader mt-3 mb-3">
        <div className="NameHeading1" style={{ width: "100%" }}>
          <button className="addCustomer"
              onClick={handleBackToReportIndex}>
              <span className="ViewUpdate">
                  <img src={LeftArrowWhite} alt="add plus icon" />
              </span>
          </button>
          <p className="config-tool-head" style={{ float: "left" }}>
            Reports &gt; {currentReport["ReportName"]}
          </p>
        </div>
      </div>
      {/* Show the "more than 1000 rows" message only if Result is 0 */}
      {reportData && reportData.length === 1 && reportData[0].Result === 0 && (
        <div className='col-lg-12 HMHeader' style={{ width: "100%" }}>
          <AlertTemplateMessage
          message={
              "Data contains more than 1000 rows. Please use the Download button to export the complete data."
          }
          />
        </div>
      )}
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "40vh",
            width: "100%",
          }}
        >
          <CircularProgress />
          <div
            style={{
              marginTop: "1rem",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Loading report data, please wait...
          </div>
        </div>
      ) : reportData && reportData.length === 1 && reportData[0].Result === 0 ? (
        // For Result: 0, don't show table, just the message above
        <div></div>
      ) : reportData && reportData.length > 0 ? (
        // Show table for actual data
        <div className="col-lg-12 TabulerReportMainDiv MatReactTableDiv">
          <div className="card-body p-0">
            <MaterialReactTable
              columns={columns}
              data={transformedReportData}
              tableInstanceRef={tableRef}
              enableGlobalFilter={true}
              enableFacetedValues={true}
              globalFilterFn= "contains"
              enableStickyHeader
              enableColumnResizing
              columnResizeMode="onEnd"
              enableColumnOrdering={true}
              initialState={{ showColumnFilters: false }}
              muiTableContainerProps={{
                className: "MaterialTableJs",
                sx: {
                  maxHeight: "100%",
                  overflow: "auto",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  display: 'table-cell !important',   // Override flex layout
                  whiteSpace: 'normal !important',    // Allow wrapping
                  wordBreak: 'break-word !important', // Break long words
                  overflow: 'visible !important',     // Show all content
                  textOverflow: 'unset !important',   // Remove ellipsis
                  alignItems: 'start',                // Align to top if multi-line
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  display: 'table-cell',
                },
              }}
              renderTopToolbarCustomActions={({ table }) => (
                <Button variant="outlined" onClick={() => handleExportData(table)}>
                  Export
                </Button>
              )}
              muiTableHeadProps={{
                className: "myHeader",
                sx: {
                  display: transformedReportData.length === 0 ? 'none' : 'table-header-group',
                },
              }}
            />
          </div>
        </div>
      ) : (
        // Show "No records" for empty data
        <div className="col-lg-12 HMHeader" style={{ width: "100%" }}>
          <AlertTemplateMessage message={`No records to display`} />
        </div>
      )}
    </div>
  );
};

export default ReportView;
